<template>
  <div class="bg">
    <v-container class="con">
      <h1 class="light-text">Vergoedingen</h1>

      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="12" md="8" justify="center">
          <h4 class="pt-4">
            De vergoedingen zijn ondergebracht in twee soorten zorg
            (Zorgverzekeringswet).
          </h4>
          <div class="column">
              <li> De Generalistische Basis GGZ (GB-GGZ)</li>
              <li> De Gespecialiseerde GGZ (S-GGZ)</li>
          </div>
          <h4>{{ text1 }}</h4>

          <h3 class="pt-4">Vergoedingen</h3>
          <h4>
            Domijn biedt alleen behandelingen aan binnen de S-GGZ. Deze wordt vergoed vanuit uw basisverzekering. Er zijn WEL kosten verbonden aan de behandeling, uw eigen risico wordt namelijk aangesproken en het is aanbevolen om u goed te laten informeren door uw zorgverzekeraar over eventuele extra kosten. De tarieven worden vastgesteld door de NZA: zie verderop bij TARIEVEN.
            Uw huisarts schrijft de verwijsbrief  met daarom de vermelding S-GGZ, de AGBpcode van de huisarts, uw BSN-nummer en uw verzekeringsgegevens. 
            Zonder een geldige verwijsbrief kunnen we ( dit een verplichting ) geen intake/behandeling starten.
          </h4>
          <h4>Voor bijna alle verwijzingen wordt de GGZ zorg vergoed, behalve voor:</h4>
          <div class="column">
              <li> Aanpassingsstoornissen (verwerking/rouw) </li>
              <li> Relatietherapie </li>
          </div>
          <h4>Deze behandelingen worden bij Domijn niet aangeboden. U kunt hiervoor bij uw huisarts een verwijsadvies vragen.</h4>

          <h3 class="pt-4">Verplicht eigen risico</h3>
          <h4>{{ eigenrisico }}</h4>

          <h3 class="pt-4">Tarieven</h3>
          <h4>Domijn hanteert tarieven volgens de geldende NZA richtlijnen. Die worden dus door de overheid bepaald voor specialisten in de zorg. 
          Domijn declareert de factureren rechtstreeks bij uw zorgverzekeraar
          De Nederlandse Zorg Authoriteit (NZA) is verantwoordelijk voor de kostprijsberekeningen en analyses. 
          De beroepsvereniging van onze praktijk, de LVVP, behartigd de belangen van de patiënt en de hulpverleners in de onderhandelingen met de NZA en de zorgverzekeraars.
          </h4>
          <h4>Voor vragen hierover kunt u terecht bij de LVVP.nl of uw zorgverzekeraar. Voor het deelnemen in groepen is het tarief per bijeenkomst afhankelijk van de soort behandelaar, het aantal behandelaren en het aantal deelnemers per bijeenkomst. Dit kan dus variëren en is na de sessie definitief. Dit kan nooit op voorhand met zekerheid worden ingeschat. </h4> 
          <h4>Domijn heeft in 2027 contracten met alle verzekeraars, behalve met SALLAND. </h4>

          <v-simple-table class="mt-6 tarifs-table pt-4">
            <template v-slot:default>
              <caption>
                <strong>Leidraad voor de tarieven bij Domijn in 2026</strong>
              </caption>
              <thead>
                <tr>
                  <th>Functie</th>
                  <th>Code</th>
                  <th>Type</th>
                  <th>Tijd</th>
                  <th>Tarief (€)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">Klinisch Psycholoog (Wet BIG artikel 14)</td>
                  <td>CO0538</td>
                  <td>Diagnostiek</td>
                  <td>60 minuten</td>
                  <td>265,97</td>
                </tr>
                <tr>
                  <td>CO0603</td>
                  <td>Behandeling</td>
                  <td>60 minuten</td>
                  <td>233,63</td>
                </tr>

                <tr>
                  <td rowspan="2">GZ-Psycholoog (Wet BIG artikel 3)</td>
                  <td>CO0562</td>
                  <td>Diagnostiek</td>
                  <td>60 minuten</td>
                  <td>200,99</td>
                </tr>
                <tr>
                  <td>CO0627</td>
                  <td>Behandeling</td>
                  <td>60 minuten</td>
                  <td>177,89</td>
                </tr>

                <tr>
                  <td rowspan="2">Psychotherapeut (Wet BIG artikel 3)</td>
                  <td>CO0570</td>
                  <td>Diagnostiek</td>
                  <td>60 minuten</td>
                  <td>231,50</td>
                </tr>
                <tr>
                  <td>CO0635</td>
                  <td>Behandeling</td>
                  <td>60 minuten</td>
                  <td>205,96</td>
                </tr>

                <tr>
                  <td rowspan="2">Psychiater (arts - specialist sectie II, vrijgevestigd)</td>
                  <td>CO0529</td>
                  <td>Diagnostiek</td>
                  <td>60 minuten</td>
                  <td>284,00</td>
                </tr>
                <tr>
                  <td>CO0594</td>
                  <td>Behandeling</td>
                  <td>60 minuten</td>
                  <td>258,59</td>
                </tr>

                <tr>
                  <td>Basispsycholoog en vaktherapeut</td>
                  <td>-</td>
                  <td>Behandeling</td>
                  <td>60 minuten</td>
                  <td>90,00</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <h4>De bedragen zijn mede afhankelijk van de diagnose en van de sessietijden.</h4>

          <h3 class="pt-4">No show</h3>
          <h4>{{ noshow }}</h4>
        </v-col>

        <v-col cols="12" md="4" justify="center">
          <v-img :src="boom" contain height="600px" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Vergoeding",
  data() {
    return {
      text1:
        "Domijn biedt behandelingen aan die vallen onder de S-GGZ. Met uw huisarts bespreekt u welke verwijzing u nodig heeft.",
      eigenrisico:
        "Voor verzekerden van 18 jaar en ouder geldt in de basisverzekering een wettelijk verplicht eigen risico van €385,- per kalenderjaar. Sommige verzekerden hebben een hoger eigen risico dat kan oplopen tot 885€, afhanekelijk van de keuze die u heeft gemaakt bij de afsluiting van uw polis. Uw eigen risico wordt in het jaar waarin uw behandeling start aangesproken en wordt geïnd door uw zorgverzekeraar. Elk kalenderjaar zal de zorgverzekeraar opnieuw het eigen risico in rekening brengen. Ons secretariaat en uw eigen zorgverzekeraar kunnen u verder uitleg geven over de totale kosten die een behandeling kan hebben.",
      noshow:
        "Het secretariaat van Domijn brengt €90,00 in rekening indien u niet verschijnt op uw afspraak en u zich niet van tevoren met een geldige reden hebt afgemeld. We vragen u om dat met voorkeur minimaal 24 uur van tevoren te doen. U kunt deze kosten niet declareren bij uw zorgverzekeraar.",
      boom: require("../assets/boom/boom2.jpg"),
    };
  },
});
</script>

<style scoped>
.bg {
  background-color: #a7955e;
}
.column-container {
  display: flex;
}
.column {
  flex: 1;
  padding: 10px;
}
</style>
